/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Step1_DescInputs */

const en_serve_step1_desc = /** @type {(inputs: Serve_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Node.js is the small program that runs the helper. Download the LTS version, install it, done.`)
};

const id_serve_step1_desc = /** @type {(inputs: Serve_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Node.js adalah program kecil yang menjalankan asisten. Unduh versi LTS, pasang, selesai.`)
};

/**
* | output |
* | --- |
* | "Node.js is the small program that runs the helper. Download the LTS version, install it, done." |
*
* @param {Serve_Step1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_step1_desc = /** @type {((inputs?: Serve_Step1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Step1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_step1_desc(inputs)
	return en_serve_step1_desc(inputs)
});